import { render, staticRenderFns } from "./FichaPostulante.vue?vue&type=template&id=361d97f4&scoped=true&"
import script from "./FichaPostulante.vue?vue&type=script&lang=js&"
export * from "./FichaPostulante.vue?vue&type=script&lang=js&"
import style0 from "./FichaPostulante.vue?vue&type=style&index=0&id=361d97f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361d97f4",
  null
  
)

export default component.exports